(($, Drupal, once) => {
  function mobileMenuStopPropogation(togglers) {
    togglers.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });
  }

  Drupal.behaviors.mobileMenu = {
    attach: (context) => {
      once('mobileMenu', 'html', context).forEach(() => {
        const header = document.querySelector('#header');
        const allDropdownToggles = header.querySelectorAll('.dropdown-toggle');
        const sportsNav = header.querySelector('.sports-navigation-region');
        const sportsMenuDropdown = sportsNav.querySelector(
          '#sportsMenuDropdown',
        );
        const sportsMobileWrapper = sportsNav.querySelector(
          '.toggle-sports-mobile-wrapper',
        );
        const mainNav = header.querySelector('.main-navigation-region--mobile');
        let activeClasses;

        // Stops propogation of the click event on bootstrap dropdown toggles.
        // This allows us to have a multi-level menu without the child dropdown closing the parent.
        mobileMenuStopPropogation(allDropdownToggles);

        // Checks which menu has the active menu item in it. Keeps dropdown menu opening scoped to that menu.
        if (sportsNav.querySelector('.is-active')) {
          activeClasses = sportsNav.querySelectorAll('.active');
          sportsMenuDropdown.classList.add('show');
          sportsMenuDropdown.setAttribute('aria-expanded', 'true');
          sportsMobileWrapper.classList.add('show');
        } else if (mainNav.querySelector('.is-active')) {
          activeClasses = mainNav.querySelectorAll('.active');
        }

        // Opens dropdown menus to reveal the active menu item
        if (activeClasses) {
          activeClasses.forEach((activeListItem) => {
            const activeDropdown =
              activeListItem.querySelector('.dropdown-menu');
            const activeToggle =
              activeListItem.querySelector('.dropdown-toggle');

            if (activeDropdown) {
              activeDropdown.classList.add('show');
              activeToggle.setAttribute('aria-expanded', 'true');
            }
          });
        }
      });
    },
  };
})(jQuery, Drupal, once, this);
